import React from 'react'
import "./Service2.css"

const ServicesData = [
    {
        'icon': "https://i.ibb.co/v6y4hK9R/Getty-Images-1149710012-1-jpg.webp",
        'title': 'Dentures',
        'description': 'Custom dentures for a natural and comfortable smile.',
    },
    {
        'icon': "https://i.ibb.co/vxhNTCkm/dental-implants-clinic-hyderabad-bangalore.webp",
        'title': 'Implants',
        'description': 'Permanent, natural-looking solution for missing teeth.',
    },
    {
        'icon': "https://i.ibb.co/Y4LHyDTL/Teeth-Whitening-768x735-jpg-optimal.jpg",
        'title': 'Whitening',
        'description': 'Safe and effective teeth whitening for a bright smile.',
    },
    {
        'icon': "https://i.ibb.co/bj5H4fjR/root-canal-vs-crown-e1658589151468.jpg",
        'title': 'Root Canal',
        'description': 'Gentle treatment to relieve pain and save your tooth.',
    }
]

const Service2 = () => {
  return (
    <div className='services-wrapper'>
      <h1 className='service-heading'>Our Dental Services</h1>

      <div className="services-grid">
        {ServicesData.map((e, i) => (
          <div className="service-card" key={i}>
            <div className="service-img-area">
              <img src={e.icon} alt={e.title} />
            </div>

            <div className="service-content">
              <h5>{e.title}</h5>
              <p>{e.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Service2;
